<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div
          class="modal-container px-md-5 p-4 py-md-4"
          :class="{overflow_initial: from == 'did_repository'}"
          :style="{width:container_width, height:container_height}"
        >
        <slot name="closemodal">
          <div class="row no-gutters">
            <button
              type="button"
              @click="$emit('close')"
              data-dismiss="alert"
              aria-label="Close"
              class="close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
        </slot>
          <div class="clearfix"></div>
          <div class="row no-gutters">
            <div class="modal-header">
              <slot name="header">default header</slot>
            </div>
            <div class="modal-body">
              <slot name="body">default body</slot>
            </div>

            <div class="modal-footer">
              <slot name="footer">
                default footer
                <button class="modal-default-button" @click="$emit('close')">OK</button>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "modal",
  props: {
    from: {
      default: null,
    },
    container_width: {
      default: null,
    },
    container_height: {
      default: null,
    },
  },
};
</script>

<style scoped>
.row {
  display: block !important;
}

.modal-mask {
  position: fixed;
  z-index: 550;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-header {
  padding: 0;
  border: 0;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  max-width: 460px;
  margin: 0px auto;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0px 20px 30px 0px rgba(21, 24, 31, 0.2);
  transition: all 0.3s ease;
  max-height: 100%;
  overflow-y: auto;
}

.modal-header h3 {
  margin-top: 0;
  color: #222;
  font-size: 24px;
}

.modal-body {
  margin: 20px 0;
  padding: 0;
}

.modal-default-button {
  float: right;
}

.modal-footer {
  border: 0;
  padding: 0;
  text-align: left;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal-container .close {
  color: #cbcbcb;
  font-size: 26px;
  font-weight: 100;
}

.modal-container .close:hover {
  opacity: 0.8;
  color: #cbcbcb;
}

.modal-container .close:focus {
  outline: none;
}
</style>
